<div class="row">
  <div class="col-md-12">
    <div class="card-header caded-innder-head-box">
      <div class="col-md-12" style="margin-bottom: 10px;">
        <div class="col-md-3">
          <input type="hidden" id="recdate" (click)="getDateWiseData()">

          <label style="color:#000; font-weight: 500;">From Date</label>
          <input id="FromDate" class="form-control" type="text" style="cursor: pointer;" placeholder="dd-mm-yyyy"
            autocomplete="off" readonly>
        </div>
        <div class="col-md-3">
          <label style="color:#000; font-weight: 500;">To Date</label>
          <input id="ToDate" class="form-control" type="text" style="cursor: pointer;" placeholder="dd-mm-yyyy"
            autocomplete="off" readonly>
        </div>

        <div class="col-sm-2">
          <label style="color:#000; font-weight: 500;">Status</label>
          <select class="wide form-control" (change)="getLeaveByStatus($event.target.value)">
            <option value="P" selected>Pending</option>
            <option value="A">Approved</option>
            <option value="R">Rejected</option>
          </select>
        </div>

      </div>
    </div>
  </div>
</div>

<div id="menu6" class="tab-pane fade1 active">
  <div class="accordion" id="accordion" role="tablist" aria-multiselectable="true">

    <div class="card panel">
      <div class="panel-heading panel_heading_gray  card-header" role="tab" id="headingOne001" data-toggle="collapse"
        data-parent="#accordion001" href="#collapseOne001" aria-expanded="false" aria-controls="collapseOne">
        <h4>Approval Workflow <i class="fa fa-angle-down"></i></h4>
      </div>
      <div id="collapseOne001" style="padding:0;" class="panel-collapse collapse card-body in" role="tabpanel">
        <div class="row">

          <div class="col-md-12 col-sm-12">
            <div class="card">

              <div id="approval-workflow-info123">

                <div class="card-body padd-bot-0 padd-top-0">

                  <div class="row">

                    <div class="col-md-12 padd-top-0">

                      <div class="col-md-12 table-responsive bulk-attendance-outer-box Reimbursements-outer-box">


                        <table class="table user-list">
                          <thead>
                            <tr>
                              <th id="ember394" class="sortable header-user-role ember-view">
                                Type
                                <!---->
                              </th>
                              <th id="ember395" class="sortable header-user-role ember-view">
                                Count
                                <!---->
                              </th>
                              <th id="ember395" class="sortable header-user-role ember-view">
                                Action
                                <!---->
                              </th>


                              <!-- <th id="ember395"
                                  class="sortable header-user-role ember-view">
                                  Status
                                </th> -->


                              <!-- <th
                                  class="header-actions text-center">
                                  Action</th>
                              </tr> -->
                          </thead>
                          <tbody>
                            <tr *ngFor="let approval of approvalList;let i=index;">
                              <td class="ZPLRow">

                                <div class="ZPusrName">
                                  <span>{{approval.approvaltype}}<span></span></span>
                                </div>
                              </td>
                              <td class="CP">
                                {{approval.approvalcount}}
                              </td>
                              <td>
                                <div class="alwd_dur">
                                  <span class="alwd_tg">
                                    <a class="btn btn-primary" (click)="openAddApprovalModal(approval)">
                                      <i class="fa fa-eye" aria-hidden="true"></i>
                                    </a>
                                  </span>
                                </div>
                              </td>

                            </tr>
                            <!-- <tr>

                              <td class="ZPLRow">

                                <div class="ZPusrName">
                                  <span>
                                    Exit Feedback
                                    <span></span></span>
                                </div>
                              </td>
                              <td class="CP" >
                                {{exit_count}}
                              </td>
                              <td>
                                <div class="alwd_dur">
                                  <span class="alwd_tg">
                                    <a class="btn btn-primary" (click)="openAddApprovalModalForExit('exitProcess')">
                                      <i class="fa fa-eye" aria-hidden="true"></i>
                                    </a>
                                  </span>
                                </div>
                              </td>

                            </tr> -->


                          </tbody>
                        </table>

                      </div>



                    </div>




                  </div>
                </div>


              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>


<div [@grooveState]="showAddApprovalModal?'active':'inactive'" id="addApprovalWorkflow"
  class="modal add-address-form-box">
  <div [@dongleState]="showAddApprovalModal?'active':'inactive'" class="modal-dialog modal-lg">
    <div class="modal-content">
      <form (ngSubmit)="onFormSubmit($event)">
        <div class="modal-header theme-bg">
          <h4 class="modal-title">{{approvalType}} - {{leaveStatus=='P' ? 'Pending' : leaveStatus=='A'?
            'Approved':'Rejected'}} Requests
          </h4>
          <button (click)="closeAddApprovalModal()" type="button" class="close" data-dismiss="modal">×</button>
        </div>
        <div class="modal-body">

          <div class="row">


            <div class="col-md-12 ">
              <div class="manage-list-row manage-pay-select" style="padding: 0px;">

                <table class="table table-hover align-middle">
                  <thead>
                    <tr class="bg-light text-secondary">
                      <th class="ps-3" style="width: 50px;">
                        <input type="checkbox" *ngIf="leaveStatus == 'P'" [checked]="selectAll" (change)="toggleSelectAll()">
                      </th>
                      <th class="ps-3">Employee Details</th>
                      <th class="text-center action-col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let employee of approvalDataByActionType;let i=index;" class="border-bottom">
                      <td class="ps-3">
                         <input type="checkbox" *ngIf="isShowActionButton(employee)" [(ngModel)]="employee.isSelected" [ngModelOptions]="{standalone: true}" (change)="updateSelection()">
                      </td>
                      <td class="ps-3" style="cursor: pointer;" (click)="showEmpDetailsModal(employee)">
                        <div class="fw-bold">
                          <span style="font-weight: 600;">{{ employee?.emp_name }}</span>
                          <span style="font-weight: 500;color: rgb(0, 175, 219);">
                            {{employee?.orgempcode || employee?.cjcode || employee?.tpcode || employee?.tp_code}}</span>
                        </div>
                        <!-- start - Imprest -->
                        <ng-container *ngIf="approvalType == 'Imprest Request'">
                          <div class="text-muted">
                            {{ employee?.createdon }}
                          </div>
                          <div style="font-weight: 500;color: rgb(0, 175, 219);">
                            Request Amount:<span style="color: grey;"> {{employee?.amount_spent}}</span>
                          </div>
                          <div style="font-weight: 500;color: rgb(0, 175, 219);" *ngIf="leaveStatus == 'A'">
                            Approved Amount:<span style="color: grey;"> {{employee?.approved_amount_spent}}</span>
                          </div>
                        </ng-container>
                        <!-- <div class="text-muted">{{ formatDate(employee.att_date) }}</div> -->
                        <!-- end - Imprest -->

                        <!-- start - Leave -->
                        <div class="text-muted" *ngIf="approvalType == 'Leave'">
                          <span [title]="'Leave Type'">{{employee?.leavetypecode}}</span> |
                          <span [title]="'Date of Leave'">{{employee?.fromdate}} - {{employee?.todate}}</span>
                        </div>
                        <!-- start - Leave -->

                        <!-- start - Travel Request -->
                        <div class="text-muted" *ngIf="approvalType == 'Travel Request'">
                          <span [title]="'Travel Purpose'">{{employee?.purpose}}</span> |
                          <span [title]="'Date of Travel'">{{employee?.date_of_travel_from}} - {{employee?.date_of_travel_to}}</span>
                        </div>
                        <!-- end - Travel Request -->

                        <!-- start - Travel Expense -->
                        <div class="text-muted" *ngIf="approvalType == 'Travel Expense'">
                          <span [title]="'Travel Purpose'">{{employee?.purpose}}</span> |
                          <span [title]="'Date of Travel'">{{employee?.date_of_travel_from}} - {{employee?.date_of_travel_to}}</span>
                        </div>
                        <!-- end - Travel Expense -->

                        <!-- start - Reimbursement Claim -->
                        <ng-container *ngIf="approvalType == 'Reimbursement Claim'">
                          <div class="text-muted">
                            <span style="font-weight: 500; color: #333;">Expense Date:</span> {{ employee?.expense_date }} | 
                            <span style="font-weight: 500; color: rgb(0, 175, 219);">{{ employee?.reimbursement_name }}</span>
                          </div>
                          <div style="font-weight: 500; color: rgb(0, 175, 219);">
                            Claim Amount: <span style="color: grey;"> ₹{{ employee?.expense_amount }}</span>
                            <span *ngIf="employee?.approved_amount && leaveStatus == 'A'" style="margin-left: 10px;">
                              Approved Amount: <span style="color: #28a745;"> ₹{{ employee?.approved_amount }}</span>
                            </span>
                          </div>
                          <div class="mt-1" *ngIf="employee?.expense_description" style="font-size: 13px;">
                            <strong>Description: </strong> {{ employee?.expense_description }}
                          </div>
                          <div class="mt-1" *ngIf="employee?.document_details?.length" style="font-size: 13px;">
                            <strong>Receipts: </strong>
                            <span *ngFor="let doc of employee.document_details; let docIdx = index" style="margin-right: 8px;">
                              <a (click)="viewDocument(doc.dbpath || doc.file_url || doc.url || doc.doc_url || doc.filepath); $event.stopPropagation();"
                                style="cursor: pointer; text-decoration: none; color: #007bff; display: inline-flex; align-items: center; gap: 4px;">
                                <i class="fa fa-file-text-o"></i> Receipt {{docIdx + 1}}
                              </a>
                            </span>
                          </div>
                          <div class="mt-1 text-muted" *ngIf="employee?.createdon" style="font-size: 12px;">
                            Applied on: {{ employee?.createdon }}
                          </div>
                          <div class="mt-1" *ngIf="employee?.action_comment_txt" style="font-size: 13px;">
                            <strong>Remarks: </strong> <span [innerHTML]="employee?.action_comment_txt"></span>
                          </div>
                        </ng-container>
                        <!-- end - Reimbursement Claim -->

                        <!-- Attendance Date for missed punch, on duty, comp-off request, WFH request-->
                        <div class="text-muted" [title]="'Attendance Date'" *ngIf="approvalType != 'Reimbursement Claim' && employee?.att_date">{{ formatDate(employee.att_date) }}</div>

                        <!-- start - missed punch -->
                        <div class="text-muted" *ngIf="approvalType == 'Missed Punch'">
                          <span style="font-weight: 500;color: rgb(0, 175, 219);"  [title]="'Missed Punch Category'">
                            {{employee?.att_catagory_txt}}</span>
                        </div>
                         <div class="mt-top" *ngIf="(employee?.mis_punch_approval_status == 'P' || employee?.approval_status == 'Pending') && employee?.approval_name_pending">
                          <!-- {{employee?.approval_status}}  -->
                          Pending at {{employee?.approval_name_pending}}
                        </div>
                        <!-- end - missed punch -->

                        <!-- start - on duty -->
                        <ng-container
                          *ngIf="approvalType == 'On Duty' || approvalType == 'Comp-Off Request' || approvalType == 'WFH Request'">
                          <div class="text-muted">
                            <span style="font-weight: 500; color: rgb(0, 175, 219);" [title]="'Description'">
                              <ng-container *ngIf="approvalType === 'On Duty'; else checkWFH">
                                {{ employee?.od_description }}
                              </ng-container>

                              <ng-template #checkWFH>
                                <ng-container *ngIf="approvalType === 'WFH Request'; else checkCompOff">
                                  {{ employee?.wfh_description }}
                                </ng-container>
                              </ng-template>

                              <ng-template #checkCompOff>
                                <ng-container *ngIf="approvalType === 'Comp-Off Request'">
                                  {{ employee?.compoff_description }}
                                </ng-container>
                              </ng-template>
                            </span>
                          </div>
                          <div class="text-muted">{{ employee?.createdon }}</div>
                        </ng-container>
                        <!-- end - on duty -->
                      </td>

                      <td class="text-center action-col">
                        <ng-container *ngIf="leaveStatus==='P'">
                          <div class="mt-top" *ngIf="(employee?.approval_status == 'Pending' || employee?.mis_punch_approval_status == 'P' || employee?.mis_punch_approval_status == 'Pending' || approvalType == 'Missed Punch' || employee?.travel_request_status == 'P'|| employee?.travel_expense_status == 'S') && !isShowActionButton(employee) && employee?.approval_name_pending">
                            <!-- {{employee?.approval_status}}  -->
                            Pending at {{employee?.approval_name_pending}}
                          </div>
                          <button class="btn btn-primary btn-sm me-2 mt-top btn-w"
                            (click)="openAddremark('A',employee,activeLeaveType.approvaltype)"
                            *ngIf="isShowActionButton(employee)">Approve</button>
                          <button class="btn btn-danger btn-sm mt-top btn-w"
                            (click)="openAddremark('R',employee,activeLeaveType.approvaltype)"
                            *ngIf="isShowActionButton(employee)" style="margin-left: 5px;">Reject</button>
                          <button class="btn btn-warning btn-sm mt-top btn-send-back"
                            (click)="openAddremark('SB',employee,activeLeaveType.approvaltype)"
                            *ngIf="canSendBack(employee)" style="margin-left: 5px;">Send Back</button>
                        </ng-container>
                        <ng-container *ngIf="leaveStatus==='A'">
                          <button class="btn btn-primary btn-sm me-2 mt-top" disabled>{{ (employee?.approval_status == 'Pending' && employee?.approval_name_pending) ? 'Pending at ' + employee?.approval_name_pending : 'Approved' }}</button>
                          <button class="btn btn-warning btn-sm mt-top btn-pull-back"
                            *ngIf="canPullBack(employee)"
                            (click)="openAddremark('PB',employee,activeLeaveType.approvaltype)"
                            style="margin-left: 5px;">Pull Back</button>
                        </ng-container>
                        <ng-container *ngIf="leaveStatus==='R'"><button class="btn btn-danger btn-sm me-2 mt-top" disabled >Rejected</button></ng-container>
                      </td>

                    </tr>
                    <!-- </div> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" *ngIf="selectedCount > 0" (click)="openBulkApproveModal('A')">Bulk Approve ({{selectedCount}})</button>
          <button type="button" class="btn btn-danger" *ngIf="selectedCount > 0" (click)="openBulkApproveModal('R')">Bulk Reject ({{selectedCount}})</button>
          <input type="button" class="btn btn-default" data-dismiss="modal" value="Close"
            (click)="closeAddApprovalModal()">
        </div>
      </form>
    </div>
  </div>
</div>

<div [@grooveState]="showBulkApproveModal?'active':'inactive'" id="bulkApproveModal" class="modal add-address-form-box">
  <div [@dongleState]="showBulkApproveModal?'active':'inactive'" class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header theme-bg">
        <h4 class="modal-title">Bulk {{bulkActionType == 'A' ? 'Approve' : 'Reject'}} Confirmation</h4>
        <button (click)="closeBulkApproveModal()" type="button" class="close" data-dismiss="modal">×</button>
      </div>
      <div class="modal-body">
        <p>You are about to {{bulkActionType == 'A' ? 'approve' : 'reject'}} <strong>{{selectedCount}}</strong> requests.</p>
        <div class="form-group">
           <label>Remarks</label>
           <textarea class="form-control" [(ngModel)]="bulkRemarks" rows="3" placeholder="Enter remarks for all selected requests"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="bulkApproveAction()">Confirm {{bulkActionType == 'A' ? 'Approve' : 'Reject'}}</button>
        <button type="button" class="btn btn-default" (click)="closeBulkApproveModal()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<div [@grooveState]="isShowEmpDetails?'active':'inactive'" id="addApprovalWorkflow" class="modal add-address-form-box">
  <div [@dongleState]="isShowEmpDetails?'active':'inactive'" class="modal-dialog">
    <div class="modal-content">
      <form>
        <div class="modal-header theme-bg">
          <h4 class="modal-title">{{modalHeadText}}</h4>
          <button (click)="hideEmpDetailModal()" type="button" class="close" data-dismiss="modal">×</button>
        </div>
        <div class="modal-body">

          <div class="row">
            <!-- Leave - start -->
            <div class="leave-block" *ngIf="approvalType =='Leave'">
              <div class="col-md-12" style="line-height: 25px;">
                <strong>Employee Name</strong><br>
                <span>{{empDetails?.emp_name}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;">
                <strong>Employee Code</strong><br>
                <span> {{empDetails?.orgempcode || empDetails?.cjcode || empDetails?.tpcode || empDetails?.tp_code}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;">
                <strong>Leave Type</strong><br>
                <span>{{empDetails?.leavetypecode}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;">
                <strong>Subject</strong><br>
                <span>{{empDetails?.leave_subject}}</span>
              </div>
              <div class="col-md-12">
                <strong>Description</strong><br>
                <span>{{empDetails?.leave_description}}</span>
              </div>
              <div class="col-md-12">
                <strong>From Date</strong><br>
                <span>{{empDetails?.fromdate}}</span>
              </div>
              <div class="col-md-12">
                <strong>To Date</strong><br>
                <span>{{empDetails?.todate}}</span>
              </div>
              <div class="col-md-12">
                <strong>Application status</strong><br>
                <span>{{empDetails?.approval_status}}</span>
              </div>
              <div class="col-md-12">
                <strong>Leave Account Details -</strong><br>
                <span>Current Balance: {{leaveDetailsForApproval?.leave_balance[0]?.cur_bal}}</span><br>
                <span *ngIf="leaveDetailsForApproval?.leave_info">Leave Taken: {{leaveDetailsForApproval?.leave_balance[0]?.leave_taken}}</span>
                <br>
                <strong>Last Leave History - </strong><br>
                <table class="table table-hover align-middle" style="margin-top: 10px;">
                  <thead>
                    <tr class="bg-light text-secondary">
                      <th class="ps-3">From Date</th>
                      <th class="ps-3">To Date</th>
                      <th class="ps-3">Total Availed</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let employee of leaveDetailsForApproval?.leave_info;" class="border-bottom">
                      <td class="ps-3">{{employee?.fromdate}}</td>
                      <td class="ps-3">{{employee?.todate}}</td>
                      <td class="ps-3">{{employee?.tot_leave}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-12" *ngIf="!addRemarks">
                <strong>Remarks</strong><br>
                <span [innerHtml]="empDetails?.action_comment_txt"></span>
              </div>

              <!-- start - Add Remarks -->
              <div class="col-md-12 " *ngIf="addRemarks">
                <strong>Remarks</strong>
                <!-- <span class="text-danger">*</span> -->
                <input type="text" class="form-control" placeholder="Enter remarks" [(ngModel)]="remarks"
                  [ngModelOptions]="{standalone:true}">
              </div>
              <!-- end - Add Remarks -->

            </div>
            <!-- Leave - end -->

            <div class="travel-block" *ngIf="approvalType !='Leave'">
              <!-- On Duty/Comp-Off/WFH Request/Missed Punch - Start -->
              <div class="col-md-12" style="line-height: 25px;"
                *ngIf="approvalType == 'On Duty' || approvalType == 'Comp-Off Requests' || approvalType == 'WFH Request' || approvalType == 'Missed Punch'">
                <strong>Employee Name</strong><br>
                <span>{{empDetails?.emp_name}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;" *ngIf="approvalType == 'On Duty' || approvalType == 'Comp-Off Requests' || approvalType == 'WFH Request' || approvalType == 'Missed Punch'">
                <strong>Employee Code</strong><br>
                <span> {{empDetails?.orgempcode || empDetails?.cjcode || empDetails?.tpcode || empDetails?.tp_code}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;" *ngIf="approvalType == 'On Duty'">
                <strong>Description</strong><br>
                <span>{{empDetails?.od_description}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;" *ngIf="approvalType == 'On Duty'">
                <strong>Created On</strong><br>
                <span>{{empDetails?.createdon}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;"
                *ngIf="approvalType == 'On Duty' || approvalType == 'WFH Request'">
                <strong>From Date </strong><br>
                <span>{{empDetails?.fromdate}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;"
                *ngIf="approvalType == 'On Duty' || approvalType == 'WFH Request'">
                <strong>To Date</strong><br>
                <span>{{empDetails?.todate}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;" *ngIf="approvalType == 'On Duty'">
                <strong>Approval Status</strong><br>
                <span>{{empDetails?.approval_status}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;" *ngIf="approvalType == 'Missed Punch'">
                <strong>Attendance Date</strong><br>
                <span>{{empDetails?.att_date}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;" *ngIf="approvalType == 'Missed Punch'">
                <strong>Check-In Time</strong><br>
                <span>{{empDetails?.check_in_time}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;" *ngIf="approvalType == 'Missed Punch'">
                <strong>Check-Out Time</strong><br>
                <span>{{empDetails?.check_out_time}}</span>
              </div>

             <div class="col-md-12" *ngIf="approvalType === 'WFH Request' && empDetails?.attachemnt_url">
                <strong>Attachment Document</strong>
                <div class="card"
                  style="width: 100px; height: 100px; padding: 10px; display: flex; align-items: center; justify-content: center; border: 1px solid #ccc; border-radius: 8px;">
                  <a [href]="empDetails?.attachemnt_url" target="_blank" rel="noopener noreferrer"
                    style="text-align: center; text-decoration: none; color: inherit;">
                    <i class="fa fa-file-pdf-o fa-2x" style="color: #d9534f;"></i>
                    <div style="font-size: 12px; margin-top: 5px;">View Attachment</div>
                  </a>
                </div>
              </div>
              <div class="col-md-12" *ngIf="approvalType === 'WFH Request' && empDetails?.approval_documents_url">
                <strong>Approval Document</strong>
                <div class="card"
                  style="width: 100px; height: 100px; padding: 10px; display: flex; align-items: center; justify-content: center; border: 1px solid #ccc; border-radius: 8px;">
                  <a [href]="empDetails?.approval_documents_url" target="_blank" rel="noopener noreferrer"
                    style="text-align: center; text-decoration: none; color: inherit;">
                    <i class="fa fa-file-pdf-o fa-2x" style="color: #d9534f;"></i>
                    <div style="font-size: 12px; margin-top: 5px;">Approval Document</div>
                  </a>
                </div>
              </div>

              <div class="col-md-12" *ngIf="approvalType == 'WFH Request' && isMoreThanTwoDays">
                <strong>Attachment:</strong> <br>
                <input class="form-control" type="file"
                 (change)="onlogoFileChange($event)">

                <!-- <ng-container *ngIf="approveRejectForm.get('wfh_attachemnt_url').errors && approveRejectForm.get('wfh_attachemnt_url').touched"
                class="text-danger">
                <p class="text-danger">Attachment is required</p>
                </ng-container> -->
              </div>
              <!-- <div class="col-md-12" *ngIf="isShowEmpDetails">
              <strong>Remarks</strong><br>
              <span [innerHTML]="empDetails?.action_comment_txt"></span>
              </div>  -->
              <!-- On Duty/WFH Request/Missed Punch - End -->

              <!-- Comp-Off Request - Start -->
              <ng-container *ngIf="approvalType == 'Comp-Off Request'">
                <!-- <div class="col-md-12" style="line-height: 25px;">
                  <strong>Employee Name</strong><br>
                  <span>{{empDetails?.emp_name}}</span>
                </div> -->

                <div class="col-md-12" style="line-height: 25px;">
                  <strong>Comp Off Date</strong><br>
                  <span>{{empDetails?.comp_off_applied_date}}</span>
                </div>
                <div class="col-md-12" style="line-height: 25px;">
                  <strong>Comp Off Request For</strong><br>
                  <span>{{(empDetails?.request_type == 'overtime')?'Extra Working Hours':'Weekoffs and Holidays'}}</span>
                </div>
                <ng-container *ngIf="(empDetails?.request_type == 'weekoff_holiday')">
                  <div class="col-md-12" style="line-height: 25px;">
                    <strong>Start Time</strong><br>
                    <span>{{empDetails?.working_start_time}}</span>
                  </div>
                  <div class="col-md-12" style="line-height: 25px;">
                    <strong>End Time</strong><br>
                    <span>{{empDetails?.working_end_time}}</span>
                  </div>
                  <div class="col-md-12" style="line-height: 25px;">
                    <strong>Working Hours</strong><br>
                    <span>{{empDetails?.working_hours}}</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="(empDetails?.request_type == 'overtime')">
                  <div class="col-md-12" style="line-height: 25px;">
                    <strong>Extra Working Hours</strong><br>
                    <span>{{empDetails?.extra_working_hrs}}</span>
                  </div>
                </ng-container>
                <div class="col-md-12" *ngIf="approvalType === 'Comp-Off Request'">
                  <strong>Document</strong>
                  <div class="card"
                    style="width: 100px; height: 100px; padding: 10px; display: flex; align-items: center; justify-content: center; border: 1px solid #ccc; border-radius: 8px;">
                    <a [href]="empDetails.attachemnt_url" target="_blank" rel="noopener noreferrer"
                      style="text-align: center; text-decoration: none; color: inherit;">
                      <i class="fa fa-file-pdf-o fa-2x" style="color: #d9534f;"></i>
                      <div style="font-size: 12px; margin-top: 5px;">View</div>
                    </a>
                  </div>
                </div>

                <!-- <div class="col-md-12" *ngIf="approvalType === 'Comp-Off Request'">
                <strong>Document</strong>
                <div class="card" style="width: 75%; height: 200px; margin-bottom: 10px;">
                  <iframe
                    [src]="empDetails.attachemnt_url | safeUrl"
                    width="100%"
                    height="100%"
                    style="border: none;"
                  ></iframe>
                </div>
                <a [href]="empDetails.attachemnt_url" target="_blank" rel="noopener noreferrer"
                  style="color: #00afdb; text-decoration: underline;">
                  View
                </a>
              </div> -->

                <!-- start - Add Approve Leave -->
                <div class="col-md-12" *ngIf="addRemarks && compoff_leaves_flag == 'A'">
                  <strong>Approve Leave</strong><span class="text-danger">*</span>
                  <input type="number" class="form-control" placeholder="Enter Approve Leave"
                    [(ngModel)]="compoff_leaves" [ngModelOptions]="{ standalone: true }" step="0.01" min="0"
                    [attr.max]="empDetails?.max_leaves_per_compoff" (input)="onInputLimit($event)" />
                </div>
                <span *ngIf="addRemarks && compoff_leaves_flag == 'A'" style=" margin: 17px;color:red">
                  <small>Max leaves allowed per comp-off is {{empDetails?.max_leaves_per_compoff}}</small>
                </span>

                <!-- <div class="col-md-12" *ngIf="addRemarks && compoff_leaves_flag === 'A'">
                <strong>Approve Leave</strong><span class="text-danger">*</span>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  [max]="empDetails?.max_leaves_per_compoff"
                  class="form-control"
                  placeholder="Enter Approve Leave"
                  [(ngModel)]="compoff_leaves"
                  [ngModelOptions]="{ standalone: true }"
                  [value]="empDetails?.comp_off_days"/>
              </div> -->

              </ng-container>
              <!-- Comp-Off Request - End -->

              <!-- Imprest Request - Start -->
              <ng-container *ngIf="approvalType == 'Imprest Request'">
                <div class="col-md-12" style="line-height: 25px;">
                  <strong>Employee Name</strong><br>
                  <span>{{ empDetails?.emp_name }}</span>
                  <span style="font-weight: 500;color: rgb(0, 175, 219);">
                    {{empDetails?.orgempcode || empDetails?.cjcode || empDetails?.tpcode || empDetails?.tp_code}}</span>
                </div>
                <div class="col-md-12" style="line-height: 25px;">
                  <strong>Expense Category</strong><br>
                  <span>{{ empDetails?.expense_category_name }}</span>
                </div>
                <div class="col-md-12" style="line-height: 25px;">
                  <strong>Expense Description</strong><br>
                  <span>{{ empDetails?.imprest_reim_description }}</span>
                </div>
                <div class="col-md-12" style="line-height: 25px;">
                  <strong>Expense Amount</strong><br>
                  <span>{{ empDetails?.amount_spent }}</span>
                </div>
                <div class="col-md-12" style="line-height: 25px;">
                  <strong>Date of Expense</strong><br>
                  <span>{{ empDetails?.date_of_expense }}</span>
                </div>
                <div class="col-md-12 " *ngIf="addRemarks && activeEmp.action == 'A'">
                  <strong>Expense Amount</strong><span class="text-danger">*</span>
                  <input type="number" class="form-control" placeholder="Enter Amount" [(ngModel)]="expense_amount"
                    [ngModelOptions]="{standalone:true}" (ngModelChange)="validateExpenseAmount()">
                  <small class="text-danger" *ngIf="expenseAmountError">
                    Entered amount should not exceed {{ empDetails?.amount_spent }}
                  </small>
                </div>
              </ng-container>
              <!-- Imprest Request - End -->



              <!-- Start - Travel Request || Travel Expense -->
              <ng-container *ngIf="approvalType == 'Travel Request' || approvalType == 'Travel Expense'">
                <div class="col-md-12" style="line-height: 25px;">
                <strong>Employee Name</strong><br>
                <span>{{empDetails?.emp_name}}</span>
              </div>
              <div class="col-md-12" style="line-height: 25px;">
                <strong>Employee Code</strong><br>
                <span> {{empDetails?.orgempcode || empDetails?.cjcode || empDetails?.tpcode || empDetails?.tp_code}}</span>
              </div>
                <div class="col-md-12" style="line-height: 25px;">
                  <strong>Purpose</strong><br>
                  <span>{{empDetails?.purpose}}</span>
                </div>
                <div class="col-md-12" style="line-height: 25px;">
                  <strong>Place of Travel</strong><br>
                  <span>From :{{empDetails?.place_of_travel_from}}</span><br>
                  <span>To :{{empDetails?.place_of_travel_to}}</span><br>
                </div>
                <div class="col-md-12">
                  <strong>Date of Travel</strong><br>
                  <span>From : {{empDetails?.date_of_travel_from}}</span><br>
                  <span>To : {{empDetails?.date_of_travel_to}}</span>
                </div>
                <div class="col-md-12">
                  <strong>Mode of Travel</strong><br>
                  <span>{{empDetails?.mode_of_travel}}</span>
                </div>
                <div class="col-md-12">
                  <strong>Travel Advance</strong><br>
                  <span>{{empDetails?.travel_adv_flag}}</span>
                </div>
                <div class="col-md-12">
                  <strong>Advance Amount</strong><br>
                  <span>{{empDetails?.travel_adv_amount }}</span>
                </div>
                <div class="col-md-12" *ngIf="approvalType === 'Travel Request'">
                  <strong>Application status</strong><br>
                  <ng-container [ngSwitch]="empDetails?.travel_request_status">
                    <ng-container *ngSwitchCase="'P'">
                      <ng-container *ngIf="empDetails && empDetails.travel_request_status === 'P'">
                        <span *ngIf="!isShowActionButton(empDetails) && empDetails?.approval_name_pending">
                          Pending at  {{
                          empDetails?.approval_name_pending
                          }}
                        </span>
                        <span *ngIf="isShowActionButton(empDetails)">
                          Pending
                        </span>
                      </ng-container>
                    </ng-container>
                    <span *ngSwitchCase="'R'">Rejected</span>
                    <span *ngSwitchCase="'A'">Approved</span>
                    <span *ngSwitchDefault> </span>
                  </ng-container>
                </div>
                <div class="col-md-12" *ngIf="approvalType =='Travel Expense'">
                  <strong>Transportation</strong><br>
                  <span>{{empDetails?.transportation}}</span>
                </div>
                <div class="col-md-12" *ngIf="approvalType =='Travel Expense' && isTicketFile">
                  <strong>Document</strong>
                  <div class="card" style="padding:5px;flex-direction: row;">
                    <span *ngFor="let doc of empDetails.docment_file">
                      <a href="{{doc.doc_url}}" *ngIf="doc.doc_type=='Ticket'" style="margin-right: 5px;">
                        <i class="fa fa-file-pdf-o fa-lg"></i>
                      </a>
                    </span>
                  </div>
                </div>
                <div class="col-md-12" *ngIf="approvalType =='Travel Expense'">
                  <strong>Accomodation</strong><br>
                  <span>{{empDetails?.accommodation}}</span>
                </div>
                <div class="col-md-12" *ngIf="approvalType =='Travel Expense' && isHotelBill">
                  <strong>Document</strong>
                  <div class="card" style="padding:5px;flex-direction: row;">
                    <span *ngFor="let doc of empDetails.docment_file">
                      <a href="{{doc.doc_url}}" *ngIf="doc.doc_type=='Hotel Bill'" style="margin-right: 5px;">
                        <i class="fa fa-file-pdf-o fa-lg"></i>
                      </a>
                    </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <strong>Applied On</strong><br>
                  <span>{{empDetails?.createdon}}</span>
                </div>
                <div class="col-md-12"
                  *ngIf="approvalType =='Travel Request' ? empDetails?.action_comment_txt_req : empDetails?.action_comment_txt_exp">
                  <strong>Remarks</strong><br>
                  <span
                    [innerHTML]="approvalType =='Travel Request' ? empDetails?.action_comment_txt_req : empDetails?.action_comment_txt_exp"></span>
                </div>
                <div class="col-md-12 " *ngIf="approvalType=='Travel Expense' && addRemarks">
                  <strong>Amount</strong>
                  <input type="text" class="form-control" placeholder="Enter Approved Amount"
                    [(ngModel)]="approvedAmount" [ngModelOptions]="{standalone:true}">
                </div>
              </ng-container>
              <!-- End - Travel Request || Travel Expense -->

              <!-- Start - Full and Final -->
              <ng-container *ngIf="approvalType == 'Exit Clearance'">
                <div class="col-md-12">
                  <h5><strong>Exit Clearance Details</strong></h5>
                </div>

                <div class="col-md-12" *ngFor="let item of clearanceItemsArray.controls; let i = index"
                  [formGroupName]="i">
                  <div class="card p-2 mb-2" style="border: 1px solid #ddd; border-radius: 5px;">
                    <div class="row align-items-center">
                      <div class="col-md-6">
                        <strong>Item:</strong><br />
                        <span>{{ item.get('itemName')?.value }}</span>
                      </div>

                      <div class="col-md-3">
                        <strong>Status</strong>
                        <select class="form-select mt-1" formControlName="status">
                          <option value="" disabled>-- Select --</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <div *ngIf="item.get('status')?.invalid && item.get('status')?.touched"
                          class="text-danger small mt-1">
                          Selection is required.
                        </div>
                      </div>

                      <div class="col-md-3">
                        <strong>Remarks</strong>
                        <input type="text" class="form-control mt-1" formControlName="remarks"
                          placeholder="Enter Remarks" />
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <!-- End - Full and Final -->

              <!-- start - Reimbursement Claim details in modal -->
              <ng-container *ngIf="approvalType == 'Reimbursement Claim'">
                <div class="col-md-6 mb-2">
                  <strong>Reimbursement Head: </strong>
                  <div>{{ empDetails?.reimbursement_name }}</div>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>Expense Date: </strong>
                  <div>{{ empDetails?.expense_date }}</div>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>Claim Amount: </strong>
                  <div style="font-size: 16px; font-weight: 600; color: #28a745;">₹{{ empDetails?.expense_amount }}</div>
                </div>
                <div class="col-md-6 mb-2" *ngIf="empDetails?.approved_amount && !addRemarks">
                  <strong>Approved Amount: </strong>
                  <div>₹{{ empDetails?.approved_amount }}</div>
                </div>
                <div class="col-md-12 mb-2" *ngIf="empDetails?.expense_description">
                  <strong>Expense Description: </strong>
                  <div>{{ empDetails?.expense_description }}</div>
                </div>
                <div class="col-md-12 mb-2" *ngIf="empDetails?.document_details?.length">
                  <strong>Attached Receipts: </strong>
                  <div class="d-flex flex-wrap gap-2 mt-1">
                    <span *ngFor="let doc of empDetails.document_details; let docIdx = index" class="me-2">
                      <a (click)="viewDocument(doc.dbpath || doc.file_url || doc.url || doc.doc_url || doc.filepath); $event.stopPropagation();"
                         style="cursor: pointer; text-decoration: none; color: #007bff; display: inline-flex; align-items: center; gap: 4px;">
                        <i class="fa fa-file-text-o"></i> Receipt {{docIdx + 1}}
                      </a>
                    </span>
                  </div>
                </div>
                <div class="col-md-12 mb-2" *ngIf="addRemarks && compoff_leaves_flag == 'A'">
                  <strong>Approved Amount (₹) </strong>
                  <input type="number" class="form-control" placeholder="Enter Approved Amount" [(ngModel)]="approvedAmount"
                    [ngModelOptions]="{standalone:true}">
                </div>
              </ng-container>
              <!-- end - Reimbursement Claim details in modal -->

              <div class="col-md-12" *ngIf="isShowEmpDetails && !addRemarks">
                <strong>Remarks</strong><br>
                <span [innerHTML]="empDetails?.action_comment_txt"></span>
              </div>

              <!-- start - Add Remarks -->
              <div class="col-md-12 " *ngIf="addRemarks">
                <strong>Remarks </strong>
                <span class="text-danger" *ngIf="approvalType == 'Imprest Request' || (approvalType == 'Reimbursement Claim' && (compoff_leaves_flag == 'R' || compoff_leaves_flag == 'SB' || compoff_leaves_flag == 'PB'))">*</span>
                <input type="text" class="form-control" [placeholder]="(approvalType == 'Reimbursement Claim' && (compoff_leaves_flag == 'R' || compoff_leaves_flag == 'SB' || compoff_leaves_flag == 'PB')) ? 'Enter Remarks (Required)' : 'Enter Remarks'" [(ngModel)]="remarks"
                  [ngModelOptions]="{standalone:true}">
              </div>
              <!-- end - Add Remarks -->

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <input type="button" class="btn btn-default" value="Submit" (click)="requestAction()" *ngIf="addRemarks">
          <input type="button" class="btn btn-default" value="Close" (click)="hideEmpDetailModal()">
        </div>
      </form>
    </div>
  </div>
</div>

<div [@grooveState]="isShowEmployeeDetails ? 'active' : 'inactive'" id="addApprovalWorkflow"
  class="modal add-address-form-box">
  <div [@dongleState]="isShowEmployeeDetails ? 'active' : 'inactive'" class="modal-dialog">
    <div class="modal-content">
      <form>
        <div class="modal-header theme-bg">
          <h4 class="modal-title">{{ 'Employee Detail' }}</h4>
          <button (click)="hideEmpDetailModal()" type="button" class="close" data-dismiss="modal">×</button>
        </div>

        <div class="modal-body">
          <div class="row">

            <!-- Employee Details Section -->
            <ng-container *ngIf="empDetails">
              <div class="col-12 mb-3">
                <!-- <div class="row g-3"> -->
                <div class="col-md-12">
                  <label class="form-label"><strong>Employee Name:</strong></label>
                  <div>{{ empDetails?.emp_name }}</div>
                </div>
                <div class="col-md-12">
                  <label class="form-label"><strong>Employee Code</strong></label>
                  <div>{{ empDetails?.emp_code }}</div>
                </div>
                <div class="col-md-12">
                  <label class="form-label"><strong>Department:</strong></label>
                  <div>{{ empDetails?.posting_department }}</div>
                </div>
                <div class="col-md-12">
                  <label class="form-label"><strong>Designation:</strong></label>
                  <div>{{ empDetails?.post_offered }}</div>
                </div>
              </div>
            </ng-container>

          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="hideEmpDetailModal()">Close</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!------------Download PDF Start------------------------>
<div class="modal" [ngStyle]="{'display':pdfModal?'block':'none'}">
  <div class="modal-dialog modal-lg ">
    <div class="modal-content ">

         <!-- <div class="loader-overlay" *ngIf="!isDataLoaded">
                <div class="loader"></div>
         </div> -->
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title"></h4>
        <button type="button" class="close modal-close-btn" data-dismiss="modal" aria-label="Close"
          data-bs-dismiss="modal" (click)="closeConfirmModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12" style="min-height:100px;">

            <iframe *ngIf="pdfModal && pdfUrlViewIdCard"
                    [src]="pdfUrlViewIdCard"
                    width="100%"
                    height="550px"
                    style="border:none;">
            </iframe>


            <!-- add by ak 15-09-2025 end -->
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!------------Download PDF End------------------------>

<!-- Document Viewer Modal -->
<div id="documentViewerModal" class="modal fade add-address-form-box in" style="z-index: 1060; background: rgba(0,0,0,0.6);">
  <div class="modal-dialog" [ngClass]="{'modal-lg': !isDocViewerMaximized}"
       [ngStyle]="isDocViewerMaximized ? {'width': '96vw', 'max-width': '96vw', 'height': '94vh', 'margin': '3vh auto'} : {'margin-top': '5vh', 'transition': 'all 0.3s ease'}">
    <div class="modal-content" [ngStyle]="isDocViewerMaximized ? {'height': '100%', 'display': 'flex', 'flex-direction': 'column', 'box-shadow': '0 10px 30px rgba(0,0,0,0.3)'} : {'box-shadow': '0 10px 30px rgba(0,0,0,0.3)'}">
      <div class="modal-header theme-bg" style="display: flex; justify-content: space-between; align-items: center; padding: 12px 20px;">
        <h4 class="modal-title" style="margin: 0; color: #fff; font-size: 16px; font-weight: 600; display: flex; align-items: center; gap: 8px;">
          <i class="fa fa-file-text-o"></i> Document Viewer
        </h4>
        <div style="display: flex; align-items: center; gap: 8px;">
          <!-- Download Button -->
          <a *ngIf="rawDocumentUrl" (click)="downloadDocument(rawDocumentUrl); $event.preventDefault();"
             href="javascript:void(0)"
             class="btn btn-sm"
             style="background: rgba(255, 255, 255, 0.2); color: #ffffff; border: 1px solid rgba(255,255,255,0.4); border-radius: 4px; padding: 4px 10px; font-size: 12px; cursor: pointer; text-decoration: none;"
             title="Download Document">
            <i class="fa fa-download"></i> Download
          </a>
          <!-- Open in New Tab -->
          <a *ngIf="rawDocumentUrl" [href]="rawDocumentUrl" target="_blank"
             class="btn btn-sm"
             style="background: rgba(255, 255, 255, 0.2); color: #ffffff; border: 1px solid rgba(255,255,255,0.4); border-radius: 4px; padding: 4px 10px; font-size: 12px; text-decoration: none;"
             title="Open in new tab">
            <i class="fa fa-external-link"></i> Open in New Tab
          </a>
          <!-- Maximize / Restore Button -->
          <button type="button" class="btn btn-sm"
             (click)="toggleDocViewerMaximize()"
             style="background: rgba(255, 255, 255, 0.2); color: #ffffff; border: 1px solid rgba(255,255,255,0.4); border-radius: 4px; padding: 4px 10px; font-size: 12px; cursor: pointer;"
             [title]="isDocViewerMaximized ? 'Restore window' : 'Maximize window'">
            <i class="fa" [ngClass]="isDocViewerMaximized ? 'fa-compress' : 'fa-expand'"></i>
          </button>
          <!-- Close Button -->
          <button type="button" class="close" (click)="closeDocumentViewer()"
             style="color: #ffffff; opacity: 0.9; font-size: 26px; line-height: 1; margin-left: 8px; background: transparent; border: none; cursor: pointer; text-shadow: none;"
             title="Close">&times;</button>
        </div>
      </div>
      <div class="modal-body" [ngStyle]="isDocViewerMaximized ? {'flex': '1', 'height': 'calc(94vh - 60px)', 'padding': '10px', 'overflow': 'auto'} : {'height': '75vh', 'padding': '10px', 'overflow': 'auto'}">
        <iframe *ngIf="documentUrlToView && !isDocumentViewImage" [src]="documentUrlToView" style="width: 100%; height: 100%; border: none;"></iframe>
        <div *ngIf="documentUrlToView && isDocumentViewImage" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #f8f9fa;">
          <img [src]="documentUrlToView" style="max-width: 100%; max-height: 100%; object-fit: contain; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
        </div>
        <div *ngIf="!documentUrlToView" class="text-center p-5 text-muted">
          No document to preview.
        </div>
      </div>
    </div>
  </div>
</div>
